<template>
  <div class="container">
    <div
      class="close-btn"
      :class="{ disabled: isProgress }"
      @click="close"
    >
      <!-- <i class="el-icon-close"></i> -->
      <iconfont
        name="#icon20-12guanbianniujiaohu"
        font-size="12px"
      ></iconfont>
    </div>
    <div class="wb-tool-upload-dialog-body">
      <div class="title">
        选择视频
      </div>
      <section class="wb-tool-upload-dialog-allwrapper">
        <div
          class="item-wrapper"
          style="margin-right:36px"
        >
          <section class="wb-tool-upload-dialog-wrapper">
            <div
              v-if="clickOnly"
              @click="onClickUpload()"
            >
              <div class="upload-dialog-icon-wrapper">
                <iconfont
                  class="upload-dialog-icon"
                  name="#icon10-21bendishangchuan"
                  font-size="32px"
                ></iconfont>
              </div>
              <p>本地上传</p>
            </div>
            <upload
              v-else
              ref="uploadComp"
              :action="'/upload/file'"
              :accept="'video/mp4'"
              :type="'video/mp4'"
              :limit="200"
              :is-upload="isUpload"
              @onReadStart="readStartHdl"
              @onOversize="oversizeHdl"
              @noSupported="noSupported"
              @onReadOver="readOverHdl"
              @onProgress="progressHdl"
              @onFinished="finishedHdl"
            >
              <div class="upload-slot">
                <div class="upload-dialog-icon-wrapper">
                  <iconfont
                    class="upload-dialog-icon"
                    name="#icon10-21bendishangchuan"
                    font-size="32px"
                  ></iconfont>
                </div>
                <p v-if="!isProgress || isUpload === false">
                  本地上传
                </p>
              </div>
            </upload>
            <div
              v-if="isUpload && isProgress"
              class="progress-wrapper"
            >
              <upload-progress
                class="progress-item"
                :percentage="percentage"
              >
                <bench-btn
                  label="取消上传"
                  style="margin-top: 20px;"
                  size="120px"
                  @click="cancelUpload"
                ></bench-btn>
              </upload-progress>
            </div>
          </section>
          <div
            class="msg"
            style="text-align: left;"
          >
            {{ uploadBtnTip || '支持格式：MP4，大小不超过 200M，时长不超过60分钟' }}
          </div>
        </div>

        <div
          class="item-wrapper"
          :class="{ disabled: isProgress }"
          style="margin-right:36px"
        >
          <section
            class="wb-tool-upload-dialog-wrapper"
            @click="callVideos"
          >
            <div class="my-videos-dialog-icon-wrapper">
              <iconfont
                class="upload-dialog-icon"
                name="#icon10-22shipinku"
                font-size="36px"
              ></iconfont>
            </div>
            <p>视频库</p>
          </section>
          <div class="msg">
            从已上传的本地视频中选取
          </div>
        </div>

        <div
          class="item-wrapper"
          :class="{ disabled: isProgress }"
        >
          <section
            class="wb-tool-upload-dialog-wrapper"
            @click="callWorks"
          >
            <div class="work-dialog-icon-wrapper">
              <iconfont
                class="upload-dialog-icon"
                name="#icon10-23wodezuopin"
                font-size="36px"
              ></iconfont>
            </div>
            <p>我的作品</p>
          </section>
          <div class="msg">
            从我的平台作品中选取
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import upload from '@/components/global/upload.vue';
import benchBtn from '@/components/global/benchBtn.vue';
import uploadProgress from '@/components/global/uploadProgress';
import contentMixin from './contentMixin';
import { mapGetters } from 'vuex';
import CheckMultiLogin from '@/mixins/checkMultiLogin.vue';

export default {
  name: 'SelectContent',
  components: {
    upload,
    benchBtn,
    uploadProgress
  },
  mixins: [contentMixin, CheckMultiLogin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isUpload: {
      type: Boolean,
      default: true
    },
    clickOnly: {
      type: Boolean,
      default: false
    },
    onClickUpload: {
      type: Function,
      default() {
        return () => {};
      }
    },
    uploadBtnTip: {
      type: [String, void 0],
      default: void 0
    },
    isCheckLimit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let visible;
    return {
      visible,
      isProgress: false, // 上传进度
      percentage: 0, // 上传百分比
      currentFileType: 'videoType', // 当前上传文件类型
      currentFileDuration: 0, // 当前上传视频时长
      currentFileName: '' // 当前视频名
    };
  },
  computed: {
    ...mapGetters({
      loginStatus: 'loginStatus'
    })
  },
  watch: {
    value: function(val) {
      this.visible = val;
    },
    visible: async function(val) {
      this.$emit('input', val);
      if (val) {
        this.init();
      }
    }
  },
  created() {
    if (this.$._loaded_) {
      this.isProgress = true;
      this.progressHdl(this.$._loaded_);
      this.$bus.on('bus.onProgress', this.progressHdl);
      this.$bus.on('bus.onFinished', this.finishedHdl);
    } else {
      this.isProgress = false;
      this.percentage = 0;
    }
  },
  mounted() {
    this.$emit('contentReady', this);
  },
  beforeDestroy() {
    this.unbindBus();
  },
  methods: {
    close() {
      if (this.isProgress) {
        return;
      }
      this.$modal.hide('selectModal');
    },
    // 初始化页面
    init() {
      // console.log("初始化");
    },
    // 调起我的视频库弹窗
    async callVideos() {
      // this.$bus.emit('checkLogin');
      let checkResult = (await this.checkMultiLogin()) || {};
      if (!this.loginStatus || (checkResult && checkResult.type)) {
        this.storeRegisterSource('视频添加');
        return;
      }
      this.$modal.show('videoStoreModal', {
        onInfo: this.onInfo
      });
    },
    // 调起我的作品弹窗
    async callWorks() {
      // this.$bus.emit('checkLogin');
      let checkResult = (await this.checkMultiLogin()) || {};
      if (!this.loginStatus || (checkResult && checkResult.type)) {
        this.storeRegisterSource('视频添加');
        return;
      }
      this.$emit('callWorks');
      this.$modal.show('worksModal', {
        onInfo: this.onInfo
      });
    },
    //选中本地文件开始读取
    readStartHdl() {
      this.isProgress = true;
      this.percentage = 0;
    },
    //上传文件过大
    oversizeHdl() {
      this.$message.error('上传失败！视频大小不可超过200M');
      setTimeout(() => {
        this.cancelUpload();
      }, 500);
    },
    noSupported() {
      this.$message.error('只支持MP4格式的文件');
      setTimeout(() => {
        this.cancelUpload();
      }, 500);
    },
    //文件读取完成
    readOverHdl(e) {
      this.uploadError = '';
      this.currentFileDuration = e.file.duration;
      this.currentFileName = e.file.name;
      if (e.file.duration > 3600) {
        this.$message.error('上传失败！视频时长不可超过60分钟');
        setTimeout(() => {
          this.cancelUpload();
        }, 500);
      } else if (e.file.duration < 1) {
        this.$message.error('上传失败！视频时长不可小于1秒');
        setTimeout(() => {
          this.cancelUpload();
        }, 500);
      } else {
        this.$store.commit('uploader/setVideoData', e.file);
        this.onFile(e.file);
      }
    },
    //文件读取进度
    progressHdl(e) {
      this.percentage = Math.ceil((e.loaded / e.total) * 100) > 100 ? 100 : Math.ceil((e.loaded / e.total) * 100);
    },
    //文件上传完成
    async finishedHdl(e) {
      this.$store.commit('uploader/setVideoUrl', e.data.data.filename);
      this.onUrl(e.data.data.filename, e.data.data);
      // var res = await this.$.getVideoThumbnail(this.$.handleAssetsUrl(e.data.data.filename));
      // const fileThumbnailUrl = res && res.data.data.filename;
      this.isProgress = false;
      // const file = e.data.data;
      // this.$http
      //   .post('/user/video/uploadVideo', {
      //     url: file.filename,
      //     thumbnailUrl: fileThumbnailUrl,
      //     direction: 1,
      //     times: this.currentFileDuration,
      //     fileType: 26,
      //     title: this.currentFileName
      //   })
      //   .then((res) => {
      //     if (res.data.code == 200) {
      //       var tmp = {
      //         id: res.data.data.id,
      //         fileType: 26
      //       };
      //       this.$emit('chooseWork', tmp);
      //       this.$store.commit('uploader/setVideoInfo', tmp);
      //       this.onInfo(tmp);
      //     }
      //   });
    },
    cancelUpload() {
      this.isProgress = false;
      this.percentage = 0;
      this.$refs.uploadComp.cancelHttp();
      this.unbindBus();
    },
    unbindBus() {
      this.$bus.off('bus.onProgress', this.progressHdl);
      this.$bus.off('bus.onFinished', this.finishedHdl);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './modal';
.item-wrapper {
  position: relative;
  & > section {
    background: #ffffff !important;
  }
  & .msg {
    width: 166px;
    height: 30px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a4a4a4;
    line-height: 18px;
    margin: auto;
    margin-top: 11px;
    text-align: center;
  }
  &.disabled {
    &:before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      cursor: not-allowed;
    }
  }
}
.wb-tool-upload-dialog-body {
  padding: 50px 39px 68px;

  background: #f9fafb;
  .title {
    margin-top: 4px;
    margin-bottom: 37px;
    font-size: 16px;
    font-weight: bold;
    color: #343434;
    text-align: center;
  }
  .wb-tool-upload-dialog-allwrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .wb-tool-upload-dialog-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 179px;
      height: 151px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(222, 226, 235, 1);
      border-radius: 4px;
      cursor: pointer;

      p {
        margin-top: 11px;
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }
      .upload-dialog-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background: rgba(100, 131, 255, 1);
        border-radius: 4px;
        &:hover {
          background: rgba(100, 131, 255, 0.8);
        }
      }
      .progress-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        .progress-cancel-btn {
          margin-top: 20px;
        }
        .progress-item {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
        }
      }
      .my-videos-dialog-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background: #24c6a6;
        border-radius: 4px;
        color: #fff;
        &:hover {
          background: rgba(#24c6a6, 0.8);
        }
      }
      .work-dialog-icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        background: rgba(219, 138, 237, 1);
        border-radius: 4px;
        &:hover {
          background: rgba(219, 138, 237, 0.8);
        }
      }
      .progress-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.close-btn {
  width: 12px;
  height: 12px;
  cursor: pointer;
  color: #666666;
  &:hover {
    color: #9e9e9e;
  }
  &.disabled {
    cursor: not-allowed;
  }
}

.upload-slot {
  width: 179px;
  height: 151px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
